function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export default function HeartBeatIcon(props) {
  let output = /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M670.505 582.005l-32.906-43.684-124.436 190.996-85.762-270.457-56.364 135.514h-214.9l357.961 360.207 367.693-373.731z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 594.375h156.136l-59.614-59.99h-96.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1024 580.077l-0.328-59.99-82.542 0.45 5.156-5.242c101.792-101.894 101.764-267.607-0.092-369.461-101.884-101.886-267.667-101.888-369.553 0l-64.72 64.724-64.724-64.724c-101.884-101.886-267.667-101.886-369.553 0-101.888 101.886-101.886 267.667-0.066 369.485l18.948 19.064h234.494l103.986-250.016 97.050 306.059 101.982-156.53 66.262 87.956 240.834-1.314-59.342 60.316 142.206-0.776z"
  })));
  return output;
}
